import { render, staticRenderFns } from "./GroupIncentive.vue?vue&type=template&id=a7fb1d6a&"
import script from "./GroupIncentive.vue?vue&type=script&lang=js&"
export * from "./GroupIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports